// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const SpecialAllowanceClaimStatusCriteriaFooter = props =>
    <div className='special-allowance-claim-status-criteria-footer'>
        <div className='asterisk-before'>
            <FormattedMessage id='INDICATES_REQUIRED_FIELD'/>
        </div>
        <div className='button-group'>
            <button
                className='secondary-button'
                onClick={props.handleCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!props.canRunReport}
                onClick={props.onRunReport}
                type='button'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    </div>;

SpecialAllowanceClaimStatusCriteriaFooter.displayName = 'SpecialAllowanceClaimStatusCriteriaFooter';
SpecialAllowanceClaimStatusCriteriaFooter.propTypes = {
    canRunReport: PropTypes.bool.isRequired,
    handleCriteriaReset: PropTypes.func.isRequired,
    onRunReport: PropTypes.func.isRequired
};

export default SpecialAllowanceClaimStatusCriteriaFooter;



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/components/special-allowance-claim-status-report-criteria/criteria-footer.js